/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import MetaData from './MetaData';

class FramePopUp extends Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">Frame Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {this.props.selectedFrame.get('images').filter( ( image, i ) =>
              i === 0 // returns a new array
            ).map((item,i) =>
              <div key={item.get('id')} className="col-sm-6">
                <img src={item.get('src')} alt={item.get('alt')} />
              </div>
            )}
            {this.props.selectedFrame.get('images').filter( ( image, i ) =>
              i !== 0 // returns a new array
            ).map((item,i) =>
              <div key={item.get('id')} className="col-sm-6">
                <img src={item.get('src')} alt={item.get('alt')} />
              </div>
            )}
          </div>
          <div className="clearfix" style={{height:'30px'}}></div>
          <MetaData {...this.props} />
        </Modal.Body>
      </Modal>
    );
  }
}
export default FramePopUp;